var TagalysCustomisations = {};
TagalysCustomisations.selectedGender = "mens";
TagalysCustomisations.didApplyInitialGenderFilter = false;
TagalysCustomisations.smartWidgetRecommendationsInitTimer = null;
TagalysCustomisations.smartWidgetRecommendationsCurrentId = null;
TagalysCustomisations.recommendationFadeStylesInjected = false;

TagalysCustomisations.ensureSmartWidgetFadeStyles = function () {
  if (TagalysCustomisations.recommendationFadeStylesInjected || !document || !document.head) return;
  var style = document.createElement("style");
  style.id = "tagalys-smart-widget-fade";
  style.textContent = "[data-widget='smart-widget-recommendations']{transition:opacity .2s ease;}[data-widget='smart-widget-recommendations'].tagalys-recommendations--crossfade{opacity:.5;pointer-events:none;}";
  document.head.appendChild(style);
  TagalysCustomisations.recommendationFadeStylesInjected = true;
};
TagalysCustomisations.getSelectedGenderValue = function () {
  var checked = document.querySelector('input[name="selectGender"]:checked');
  return checked ? checked.value : TagalysCustomisations.selectedGender;
};

TagalysCustomisations.recommendations = {
  mens: 'ac2881e4ac39b0cf4979',
  womens: 'aaddefaedfc4fd6d92a3',
  kids: 'eecb64b9143a5b38abcb',
  mixed: '2369ac9ebb2793d0988e'
}

TagalysCustomisations.setTagalysConfiguration = function () {
  var configuration = {
    api: {
      serverUrl: "https://api-r4.tagalys.com",
      apiKey: "tgls_v2_storefront_da0e73ca1dd668f339653cb4ea6fc06a",
    },
    locale: "en-US",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: theme.custom.currency.name,
      label: theme.custom.currency.symbol,
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function () {
      // return true/false based on user's consent settings
      return true;
    },
    track: true,
  };
  Tagalys.setConfiguration(configuration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var platformConfiguration = {
    platform: "Shopify",
    countryCode: Shopify.country,
    // replace with Shopify.country to set the shopper's chosen country
    baseCountryCode: "GB",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "93d13a025c7159b43f6470375c77484d",
      myShopifyDomain: "couture-club-2.myshopify.com",
    },
    metafields: {
      products: [],
    },
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initSmartWidgetRecommendations = function (s, id) {
  var widget = document.querySelector(s);
  if (!widget || !id) return;
  TagalysCustomisations.ensureSmartWidgetFadeStyles();
  var currentId = widget.getAttribute("data-recommendation-id");
  if (widget.getAttribute("data-widget-initialized") === "true" && currentId === id) return;

  widget.setAttribute("data-recommendation-id", id);
  widget.setAttribute("data-widget-initialized", "true");
  widget.classList.add("tagalys-recommendations--crossfade");
  requestAnimationFrame(function () {
    setTimeout(function () {
      widget.classList.remove("tagalys-recommendations--crossfade");
    }, 160);
  });
  Tagalys.UIWidgets.Recommendations.init(s,
    {
      recommendationId: id,
      templates: {
        widget: {
          labels: {
            heading: "<Widget heading>"
          },
          options: {
            count: 20,
            displayFormat: "grid",
            includeTagalysCSS: false,
          },
          render: function (html, args) {
            var props = args.props
            var helpers = props.helpers
            var products = helpers.getProducts()
            if (props.loading === false && products.length === 0) {
              return null
            }

            return html`
              <div class=${`recommendations-widget${props.loading ? " recommendations-widget--loading" : ""}`}>
                <div class="recommendations-widget-body">
                  ${props.loading ? null : html`<${args.templates.productList} />`}
                </div>
                ${props.loading ? null : html`<${args.templates.footer} />`}
              </div>
            `;
          }
        },
        product: {
          render: function (html, args) {
            return TagalysCustomisations.renderSearchSuggestionProductCard(html, args);
          },
        }
      }
    }
  );
}

TagalysCustomisations.scheduleSmartWidgetRecommendationsInit = function () {
  if (TagalysCustomisations.smartWidgetRecommendationsInitTimer) return;
  TagalysCustomisations.smartWidgetRecommendationsInitTimer = setTimeout(function () {
    TagalysCustomisations.smartWidgetRecommendationsInitTimer = null;
    var gender = TagalysCustomisations.getSelectedGenderValue();
    var id = TagalysCustomisations.recommendations[gender];
    if (!id || TagalysCustomisations.smartWidgetRecommendationsCurrentId === id) return;
    TagalysCustomisations.smartWidgetRecommendationsCurrentId = id;
    TagalysCustomisations.initSmartWidgetRecommendations("[data-widget='smart-widget-recommendations']", id);
  }, 80);
};


TagalysCustomisations.setSmartWidgetRecommendationsVisibility = function (isVisible, s) {
  var widgets = document.querySelectorAll(s);
  widgets.forEach(function (widget) {
    widget.style.display = isVisible ? "" : "none";
  });
};

TagalysCustomisations.renderSearchSuggestionProductCard = function (html, args) {
  var props = args.props;
  var product = props.product;
  var helpers = props.helpers;

  var navigateToProductDetailPage = function (event) {
    helpers.navigateToProductDetailPage(event, product);
  };

  var productOptions = helpers.getTemplateOptions('product');
  var productLink = productOptions.productPageUrl(product);
  var titleParts = (product.title || '').split(' - ');
  var titleMain = titleParts[0] || product.title || '';
  var titleSub = titleParts[1] || '';
  var primaryImage = product.featured_image && product.featured_image.src
    ? product.featured_image.src + '&width=300'
    : (product.images && product.images[0]
      ? product.images[0].src + '&width=300'
      : null);
  var secondaryImage = product.images && product.images[1]
    ? product.images[1].src + '&width=300'
    : null;
  var isOnSale = helpers.isProductOnSale(product.compare_at_price, product.price);
  var compareAtPrice = Number(product.compare_at_price);
  var currentPrice = Number(product.price);
  var discountPercent = isOnSale && Number.isFinite(compareAtPrice) && Number.isFinite(currentPrice) && compareAtPrice > 0 && currentPrice < compareAtPrice
    ? Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100)
    : null;

  var cardClasses = [
    'product-card',
    'product-card--crop',
    'js-product',
    'js-product-card',
    'js-product-' + product.id,
    product.available ? '' : 'product-card--sold-out',
    isOnSale && product.available ? 'product-card--sale' : '',
    'product-card--left'
  ].filter(Boolean).join(' ');
  
  return html`
    <div
      class=${cardClasses}
      data-product=${product.id}
      data-title=${product.title}
      data-product-id=${product.id}
      onClick=${navigateToProductDetailPage}
	    >
	      <div class="product-card-top">
	        ${discountPercent ? html`
	          <div class="percentage_discount cc-fs2 cc-uppercase">
	            <span>${discountPercent}% Off</span>
	          </div>
        ` : null}
        <a
          class="product-card__link product-card__link--full-opacity js-product-link"
          href=${productLink}
          title=${product.title}
          data-images=${product.images ? product.images.length : 0}
        >
          <div class="o-ratio o-ratio--3:4">
            <div class="o-ratio__content">
            
              ${(product.metafields?.custom?.product_grid_tag) ? html`
                <a
                  style="background: ${product.metafields?.custom?.product_grid_tag.value.tag_colour}; color: ${product.metafields?.custom?.product_grid_tag.value.tag_font_colour};"
                  class="product-card__tag cc-pointer cc-uppercase"
                >
                  ${(product.metafields?.custom?.product_grid_tag?.value?.tag_content || '').replace('[date]', product.metafields?.global?.coming_soon_eta_display?.value ?? '')}
                </a>
              ` : null}

              <div class=${`product-card__media${secondaryImage ? ' product-card__media--hover-image' : ''}`}>
                ${secondaryImage ? html`
                  <img
                    class="product-card__img-hover hover-enabled js-img-grid-hover"
                    src=${secondaryImage}
                    alt=${product.title}
                    loading="lazy"
                  />
                ` : null}
                ${primaryImage ? html`
                  <img
                    class=${`product-card__img js-img-grid${secondaryImage ? ' hover-enabled' : ''}`}
                    src=${primaryImage}
                    alt=${product.title}
                    loading="lazy"
                  />
                ` : null}
              </div>
            </div>
          </div>
        </a>
      </div>

      <div class="product-card__details">
        <a class="product-card__link js-product-link" href=${productLink} title=${product.title}>
          <h3 class="product-card__title f-family--heading f-caps--false f-space--0">
            ${titleMain.toUpperCase()}
          </h3>
        </a>

        <div class="product-card__details__hover u-medium">
          <a class="product-card__variants" href=${productLink}>
            ${titleSub ? html`<p class="colour">${titleSub}</p>` : null}
          </a>
          <a class="product-card__link js-product-link" href=${productLink} title=${product.title} tabindex="-1">
            <p class="price">
              ${isOnSale ? html`
                <strike class="price__compare">
                  <span class="money">${helpers.formatCurrency(product.compare_at_price)}</span>
                </strike>
                <span class="price__number price__number--sale">
                  <span class="money">${helpers.formatCurrency(product.price)}</span>
                </span>
              ` : html`
                <span class="price__number">
                  <span class="money">${helpers.formatCurrency(product.price)}</span>
                </span>
              `}
            </p>
          </a>
        </div>
      </div>
    </div>
  `;
};

TagalysCustomisations.initSearchSuggestions = function () {

  var setInitialGenderFromSession = function () {
    var preference = null;
    try {
      preference = window.sessionStorage ? sessionStorage.getItem('nav_preference') : null;
    } catch (error) {
      preference = null;
    }
    if (!preference) return;
    var matchingInput = document.querySelector(
      'input[name="selectGender"][value="' + preference + '"]'
    );
    if (!matchingInput) return;
    matchingInput.checked = true;
    TagalysCustomisations.selectedGender = preference;
    rerenderSearchSuggestions();
  };

  var rerenderSearchSuggestions = function () {
    var input = document.querySelector('[data-search-input]');
    if (!input) return;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  var handleGenderChange = function (event) {
    if (!event || !event.target || event.target.name !== 'selectGender') return;
    TagalysCustomisations.selectedGender = event.target.value;
    try {
      if (window.sessionStorage) {
        sessionStorage.setItem('nav_preference', TagalysCustomisations.selectedGender);
      }
    } catch (error) {
      // Ignore storage errors (e.g., disabled storage).
    }
    rerenderSearchSuggestions();
  };

  setInitialGenderFromSession();
  document.addEventListener('change', handleGenderChange);

  document.addEventListener('click', function (event) {
    var target = event && event.target;
    var trigger = target && target.closest
      ? target.closest('.js-search-trigger, .js-search-clear')
      : null;
    if (!trigger) return;

    event.preventDefault();

    var searchDraw = document.querySelector('.js-search-draw');
    var doc = document.documentElement;

    if (searchDraw) {
      rerenderSearchSuggestions();
      doc.classList.toggle('js-search-open');
      searchDraw.classList.toggle('u-hidden');
      if (doc.classList.contains('js-search-open')) {
        setTimeout(function () {
          var input = searchDraw.querySelector('[data-search-input]');
          if (input) {
            input.focus();
          }
        }, 0);
      }
    }
  });

  Tagalys.UIWidgets.SearchSuggestions.init("[data-search-input]", {

    searchResultsURL: "/search",
    templates: {
      product: {
        render: function (html, args) {
          return TagalysCustomisations.renderSearchSuggestionProductCard(html, args);
        },
      },
      clickSuggestions: {
        options: {
          selector: '.search_suggested__searches'
        },
        render: function (html, args) {
          var helpers = args.props.helpers
          var recentAndPopularSearches = helpers.getRecentAndPopularSearches()

          return html`
            <div class="click-suggestions cc-fs1">
              <div class="click-suggestions-popular">
                <div class="cc-fs1 cc-uppercase search-draw__heading">Popular Searches</div>
                ${recentAndPopularSearches.popularSearches.map(
                  popularSearch =>
                    html`
                      <${args.templates.popularSearchItem} popularSearch=${popularSearch} />
                    `
                )}
              </div>
            </div>
          `;
        }
      },
      textSuggestionSection: {
         options: {
          selector: '.search_suggested__content',
         },
        render: function (html, args) {
          var props = args.props;
          var textSuggestionSection = props.textSuggestionSection;

          return html`
            <li
              class="text-suggestion-section"
              data-section-id=${textSuggestionSection.section_id}
            >
              <span class="section-title cc-uppercase">
                ${textSuggestionSection.title}
              </span>
              <ul>
                ${textSuggestionSection.items.map(
                  function (textSuggestionSectionItem) {
                    return html`
                      <${args.templates.textSuggestionSectionItem}
                        textSuggestionSectionId=${textSuggestionSection.section_id}
                        textSuggestionSectionItem=${textSuggestionSectionItem}
                      />
                    `;
                  }
                )}
              </ul>
            </li>
          `;
        },
      },
      widget: {
        options: {
          selector: '.search-container',
          position: false,
          includeTagalysCSS: false,
          sections: {
            products: {
              include: ["total_count", "items"],
              count: 20,
            },
            collections: {
              count: 5,
            },
            pages: {
              count: 5,
            },
          },
          minimumCharactersToShowSuggestions: 3,
        },
        render: function (html, args) {
          var helpers = args.props.helpers;
          var showTypeSuggestions = helpers.exceedsMinimumCharactersToShowSuggestions();
          var TypeSuggestionsTemplate = args.templates && args.templates.typeSuggestions;
          var content = null;
          var noResultsHeading = null;

          if (showTypeSuggestions && TypeSuggestionsTemplate) {
            TagalysCustomisations.setSmartWidgetRecommendationsVisibility(false, "[data-widget='smart-widget-recommendations']");
            content = html`<${TypeSuggestionsTemplate} />`;
          } else {
            TagalysCustomisations.setSmartWidgetRecommendationsVisibility(true, "[data-widget='smart-widget-recommendations']");
            TagalysCustomisations.scheduleSmartWidgetRecommendationsInit();
          }

          if(helpers.getProducts().length == 0 && showTypeSuggestions) {
            TagalysCustomisations.setSmartWidgetRecommendationsVisibility(true, "[data-widget='smart-widget-recommendations']");
            noResultsHeading = html`
              <div class="cc-fs1 cc-uppercase search-draw__heading">No Results found for "${helpers.getEnteredSearchQuery()}"</div>
            `;
            TagalysCustomisations.scheduleSmartWidgetRecommendationsInit();
          }
          
          return html`
            ${noResultsHeading}
            <${args.templates.clickSuggestions} />
            <div class="search-suggestions">
              ${content}
            </div>
            
          `;
        },
      }
    },
    callbacks: {
      beforeAPICall: function (params) {
        var gender = TagalysCustomisations.getSelectedGenderValue();
        if (params.query == '') {
          params.query = '*';
        }
        if (params.sections?.hasOwnProperty("products")) {
          var genders = gender ? [gender] : ["kids", "womens", "mens", "unisex"];
          if (gender === 'mens' || gender === 'womens') {
            genders = [gender, 'unisex'];
          }
          params.sections.products.scope = {
            "p.m.custom.gender": genders,
          };
        }
        return params;
      },
      onSuccessfulAPICall: function(response, helpers) {

        if (response.sections.products.total_count > 0) {
   
        }
      }
    },
  });

};

//* Customisation: Attaching swatches from storefront API
// Prefix for collection handles
const COLLECTION_HANDLE_SUFFIX = "-index";

const constructCollectionHandle = (sku) =>
  sku.split("/")[0].toLowerCase() + COLLECTION_HANDLE_SUFFIX;

const graphqlCollectionQuery = (handles) => `
  query {
    ${handles
      .map(
        (handle, i) => `
      collection_${i}: collection(handle: "${handle}") {
        handle
        products(first: 100) {
          edges {
            node {
              id
              title
              handle
              featuredImage { url }
              variants(first: 100) {
                edges {
                  node {
                    sku
                    price { amount currencyCode }
                    availableForSale
                  }
                }
              }
            }
          }
        }
      }
    `
      )
      .join("\n")}
  }
`;

async function fetchCollectionsData(collectionHandles) {
  if (!collectionHandles.length) return {};

  const { storefrontAPI } = window.Tagalys.getPlatformConfiguration();
  const query = graphqlCollectionQuery(collectionHandles);

  const response = await fetch(
    `https://${storefrontAPI.myShopifyDomain}/api/2024-10/graphql.json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAPI.accessToken,
      },
      body: JSON.stringify({ query }),
    }
  );

  const { data } = await response.json();
  // Normalizing the response
  const collectionsData = {};
  Object.values(data || {}).forEach((collection) => {
    if (collection?.products) {
      collectionsData[collection.handle] = collection.products.edges.map(
        (e) => e.node
      );
    }
  });

  return collectionsData;
}

TagalysCustomisations.initSearchResults = function () {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results]", {
    templates: {
      noResults: {
        options: {
          widgets: [
            {
              recommendationId: "2369ac9ebb2793d0988e",
            },
          ],
        },
      },
      paginationLinks: {
        options: {
          showNumberedPageLinks: true,
          numberedPageLinksWindowSize: 3,
          showPreviousPageLink: true,
          showFirstPageLink: true,
          showNextPageLink: true,
          scrollTop: true
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;
          var pagesToDisplay = helpers.getPagesToDisplay(
            props.numberedPageLinksWindowSize
          );
          var currentPage = helpers.getCurrentPage();
          var hasPreviousPage = helpers.hasPreviousPage();
          var hasNextPage = helpers.hasNextPage();
          
          var goToFirstPage = () => {
            helpers.goToPage(1);
          };

          if (pagesToDisplay.length <= 1) return null;

          return html`
            <div class="pagination">
              ${props.showFirstPageLink
                ? html`
                    <button
                      class=${`btn${currentPage === 1 ? " disabled" : ""}`}
                      onclick=${currentPage === 1 ? undefined : goToFirstPage}
                    >
                      ${labels.pagination.firstPage}
                    </button>
                  `
                : null}
              ${props.showPreviousPageLink
                ? html`
                    <button
                      class=${`btn${!hasPreviousPage ? " disabled" : ""}`}
                      onclick=${currentPage === 1
                        ? undefined
                        : helpers.goToPreviousPage}
                    >
                      ${labels.pagination.previousPage}
                    </button>
                  `
                : null}
              ${props.showNumberedPageLinks
                ? pagesToDisplay.map((pageDetail) => {
                    var classes = ["btn"];
                    var showEllipsis = pageDetail.jumpAfter;
                    if (pageDetail.current) classes.push("active");
                    if (pageDetail.jumpAfter) classes.push("page-jump-over");
                    var className = classes.join(" ");
                    return html`
                      <button
                        class=${`${className}`}
                        onclick=${() => {
                          !showEllipsis && helpers.goToPage(pageDetail.page);
                        }}
                      >
                        ${showEllipsis ? "..." : pageDetail.page}
                      </button>
                    `;
                  })
                : null}
              ${props.showNextPageLink
                ? html`
                    <button
                      class=${`btn${!hasNextPage ? " disabled" : ""}`}
                      onclick=${hasNextPage ? helpers.goToNextPage : undefined}
                    >
                      ${labels.pagination.nextPage}
                    </button>
                  `
                : null}
            </div>
          `;
        },
      },
      appliedFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;

          var getHeadingBasedOnAPIResponse = () => {
            if (helpers.isPartialResults()) {
              return labels.searchResults.heading.partialMatches.replace(
                "{{searchTerm}}",
                helpers.getQuery()
              );
            }

            if (helpers.isSpellingCorrectedQuery()) {
              return labels.searchResults.heading.corrected
                .replace("{{originalSearchTerm}}", helpers.getOriginalQuery())
                .replace("{{resultsCount}}", helpers.getTotalProductsCount())
                .replace("{{correctedSearchTerm}}", helpers.getQuery());
            }

            return labels.searchResults.heading.standard
              .replace("{{resultsCount}}", helpers.getTotalProductsCount())
              .replace("{{searchTerm}}", helpers.getQuery());
          };

          var appliedFilters = helpers.getAppliedFilters(true);
          return html`
            <div class="mobile-draw__fixed mobile-draw__header u-hidden@tab-up">
              <span class="cc-fs1 cc-uppercase">Filters</span>
              <a class="cc-fs1 cc-uppercase cc-pointer js-close-mfp">Close</a>
            </div>
            <div class="cc-fs1 cc-uppercase search-draw__heading">${getHeadingBasedOnAPIResponse()}</div>
            ${!appliedFilters.length
              ? null
              : html`
                  <div class="applied-filters-container filters-container">
                    <ul class="applied-filters">
                      ${appliedFilters.map((appliedFilter) => {
                if (appliedFilter.type === "range") {
                  return html`
                    <li
                      onClick=${() => helpers.clearFilter(appliedFilter.id)}
                      class="applied-filter"
                    >
                      <span class="applied-filter-label">
                        ${helpers.labelFormatter(
                          appliedFilter.display_format,
                          appliedFilter.selected_min,
                          appliedFilter.currency
                        )}
                        -
                        ${helpers.labelFormatter(
                          appliedFilter.display_format,
                          appliedFilter.selected_max,
                          appliedFilter.currency
                        )}
                      </span>
                      <span class="applied-filter-action-clear">
                        <${args.templates.closeIcon} />
                      </span>
                    </li>
                  `;
                }
                return appliedFilter.items.map((filterItem) => {
                  return html`
                    <li
                      class="applied-filter"
                      onClick=${() =>
                        helpers.clearFilter(appliedFilter.id, filterItem.id)}
                    > 
                      <span class="applied-filter-label cc-fs1">
                        ${appliedFilter.label}: ${filterItem.label}
                      </span>
                      <span class="applied-filter-action-clear">
                        <${args.templates.closeIcon} />
                      </span>
                    </li>
                  `;
                });
              })}
                    </ul>
                  </div>
                `}
          `;
        },
      },
      filter: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels || {};
          var isCollapseOpen = false;
          if (props.collapsible) {
            isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
          }
          var showClearActionForIndividualFilters =
            props.showClearActionForIndividualFilters;
          var clearFilter = (event) => {
            if (event) {
              event.preventDefault();
              event.stopPropagation();
            }
            if (helpers.clearFilter) {
              helpers.clearFilter(props.filter);
            }
          };
          return html`
            <details
              class="collection-sidebar__filter-group filter cc-fs1"
              id=${`search-filter-${props.filterIndex != null ? props.filterIndex : props.filter.id}`}
              data-filter-id=${props.filter.id}
              ?open=${props.collapsible ? isCollapseOpen : true}
            >
              <summary class="collection-sidebar__filter-trigger">
                <span>${props.filter.label}</span>
                <summary-icon>
                  <i class="icon icon--plus" aria-hidden="true"></i>
                </summary-icon>
                ${showClearActionForIndividualFilters
                  ? html`
                      <span
                        class="filter-action-clear"
                        onClick=${clearFilter}
                      >
                        ${labels.filters
                          ? labels.filters.clearIndividualFilter
                          : "Clear"}
                      </span>
                    `
                  : null}
              </summary>
              <details-content class="collection-sidebar__filter__accordion">
                <${args.templates.filterItems} filter=${props.filter} />
              </details-content>
            </details>
          `;
        }
      },
      sortOptionInFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var labels = args.labels;

          var filterOptions = helpers.getTemplateOptions("filters");
          var appliedSortOption = helpers.getAppliedSortOption();
          var sortOptions = helpers.getSortOptions();

          var isCollapseOpen = false;
          if (filterOptions.collapsible) {
            isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
          }

          return html`
            <details
              open
              class="collection-sidebar__filter-group filter cc-fs1"
              id="search-filter-sort_options"
              data-filter-id="sort_options"
            >
              <summary class="collection-sidebar__filter-trigger">
                <span>${labels.sortOptions.sortBy}</span>
                <summary-icon>
                  <i class="icon icon--plus" aria-hidden="true"></i>
                </summary-icon>
              </summary>
              <details-content class="collection-sidebar__filter__accordion">
                <ul class="filter-checkboxes">
                  ${sortOptions.map((sortOption) => {
                    const checked = sortOption.id === appliedSortOption.id;
                    return html`
                      <li
                        class="filter-item"
                        data-filter-item-id=${sortOption.id}
                        onClick=${() => helpers.applySortOption(sortOption.id)}
                      >
                        <span class="filter-checkbox-and-label">
                          <input
                            class="checkbox"
                            checked=${checked}
                            type="checkbox"
                          />
                          <span class="filter-item-label-and-count">
                            <span class="filter-item-label">${sortOption.label}</span>
                          </span>
                        </span>
                      </li>
                    `;
                  })}
                </ul>
              </details-content>
            </details>
          `;
        },
      },
      filters: {
        options: {
          selector: '.search-filters-container',
          collapsible: true,
          includeTagalysCSS: true,
          includeSortOptionsInFilters: true,
          autoCollapse: true,
          showAppliedFilters: true,
          showClearAllFilters: false,
          showClearActionForIndividualFilters: false,
          showMatchingProductsCount: true,
          defaultExpandedFilters: ["sort_options"],
          showFiltersInDrawer: () => {
            return window.innerWidth <= 768;
          },
        },
        render: function (html, args) {
          var props = args.props;
          var labels = args.labels;
          var helpers = props.helpers;

          var getHeadingBasedOnAPIResponse = () => {
            if (helpers.isPartialResults()) {
              return labels.searchResults.heading.partialMatches.replace(
                "{{searchTerm}}",
                helpers.getQuery()
              );
            }

            if (helpers.isSpellingCorrectedQuery()) {
              return labels.searchResults.heading.corrected
                .replace("{{originalSearchTerm}}", helpers.getOriginalQuery())
                .replace("{{resultsCount}}", helpers.getTotalProductsCount())
                .replace("{{correctedSearchTerm}}", helpers.getQuery());
            }

            return labels.searchResults.heading.standard
              .replace("{{resultsCount}}", helpers.getTotalProductsCount())
              .replace("{{searchTerm}}", helpers.getQuery());
          };

          var filters = helpers.getFilters();
          var appliedFilters = helpers.getAppliedFilters(true);
          var showClearAllFiltersAction =
            props.showClearAllFilters && appliedFilters.length;
          var classes = ["filters"];
          if (props.collapsible) {
            classes.push("collapsible");
          }

          var className = classes.join(" ");
          return html`
          <div class="search-filters-heading u-hidden@tab-up">
            <div class="cc-fs1 cc-uppercase search-draw__heading">${getHeadingBasedOnAPIResponse()}</div>
            <div class="search-filters-open js-search-filters-open cc-uppercase cc-fs1">
                <svg class="icon icon-menu" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
                  <path d="M1 23H47" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path>
                  <line x1="1" y1="36" x2="47" y2="36" stroke="currentColor" stroke-width="4" stroke-linecap="round"></line>
                  <line x1="1" y1="10" x2="47" y2="10" stroke="currentColor" stroke-width="4" stroke-linecap="round"></line>
                </svg>
                <div>Filters</div>
            </div>
          </div>
          <div class="u-hidden@tab-down">
            <div class="filters-draw-container">
              <div class=${className}>
                ${props.showAppliedFilters
                  ? html` <${args.templates.appliedFilters} /> `
                  : null}
                ${showClearAllFiltersAction
                  ? html`
                      <div
                        class="clear-all-filters"
                        onclick=${helpers.clearAllFilters}
                      >
                        ${labels.filters.clearAllFilters}
                      </div>
                    `
                  : null}
                ${props.includeSortOptionsInFilters === "top"
                  ? html` <${args.templates.sortOptionInFilters} /> `
                  : null}
                  <div class="filters-container">
                <accordion-group>
                ${props.includeSortOptionsInFilters === true ||
                props.includeSortOptionsInFilters === "bottom"
                  ? html` <${args.templates.sortOptionInFilters} /> `
                  : null}
                  ${filters.map(
                    (filter, index) =>
                      html`<${args.templates.filter} filter=${filter} filterIndex=${index} />`
                  )}
                </accordion-group>
                
                  </div>
              </div>
            </div>
          </div>
          `;
        },
        callbacks: {
          afterInitialRender: function(helpers) {
            var mobileFilters = document.querySelector('.js-search-filters-open');
            mobileFilters.addEventListener('click', function () {
              theme.mfpOpen("search-filters");
            });
          }
        }
      },
      pagination: {
        options: {
          infiniteScroll: true,
        },
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers

          if(props.infiniteScroll){
            if(helpers.canLoadNextResults(props.showLoadNextAfterEvery)){
              return html`<${args.templates.loadNext} />`;
            }
            return null
          }
          return html`<${args.templates.paginationLinks} />`;
        },
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var product = props.product;
          var helpers = props.helpers;

          var navigateToProductDetailPage = (event) => {
            helpers.navigateToProductDetailPage(event, product)
          }

          var productOptions = helpers.getTemplateOptions('product')
          var productLink = productOptions.productPageUrl(product)
          var titleParts = (product.title || '').split(' - ');
          var titleMain = titleParts[0] || product.title || '';
          var titleSub = titleParts[1] || '';
          var primaryImage = product.featured_image && product.featured_image.src
            ? product.featured_image.src + '&width=300'
            : (product.images && product.images[0]
              ? product.images[0].src + '&width=300'
              : null);
	          var secondaryImage = product.images && product.images[1]
	            ? product.images[1].src + '&width=300'
	            : null;
	          var isOnSale = helpers.isProductOnSale(product.compare_at_price, product.price);
	          var compareAtPrice = Number(product.compare_at_price);
	          var currentPrice = Number(product.price);
	          var discountPercent = isOnSale && Number.isFinite(compareAtPrice) && Number.isFinite(currentPrice) && compareAtPrice > 0 && currentPrice < compareAtPrice
	            ? Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100)
	            : null;
	          var sizeOption = Array.isArray(product.options_with_values)
	            ? product.options_with_values.find(function (option) {
	                return option.name && option.name.toLowerCase() === 'size';
	              })
	            : null;
          var sizeValues = sizeOption && Array.isArray(sizeOption.values) ? sizeOption.values : [];

          var cardClasses = [
            'product-card',
            'product-card--crop',
            'js-product',
            'js-product-card',
            'js-product-' + product.id,
            product.available ? '' : 'product-card--sold-out',
            isOnSale && product.available ? 'product-card--sale' : '',
            'product-card--left'
          ].filter(Boolean).join(' ');

          return html`
            <div
              class=${cardClasses}
              data-product=${product.id}
              data-title=${product.title}
              data-product-id=${product.id}
              onClick=${navigateToProductDetailPage}
	            >
	              <div class="product-card-top">
	                ${discountPercent ? html`
	                  <div class="percentage_discount cc-fs2 cc-uppercase">
	                    <span>${discountPercent}% Off</span>
	                  </div>
                ` : null}
                <a
                  class="product-card__link product-card__link--full-opacity js-product-link"
                  href=${productLink}
                  title=${product.title}
                  data-images=${product.images ? product.images.length : 0}
                >
                  <div class="o-ratio o-ratio--3:4">
                    <div class="o-ratio__content">
                      <div class=${`product-card__media${secondaryImage ? ' product-card__media--hover-image' : ''}`}>
                        ${secondaryImage ? html`
                          <img
                            class="product-card__img-hover hover-enabled js-img-grid-hover"
                            src=${secondaryImage}
                            alt=${product.title}
                            loading="lazy"
                          />
                        ` : null}
                        ${primaryImage ? html`
                          <img
                            class=${`product-card__img js-img-grid${secondaryImage ? ' hover-enabled' : ''}`}
                            src=${primaryImage}
                            alt=${product.title}
                            loading="lazy"
                          />
                        ` : null}
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="product-card__details">
                <a class="product-card__link js-product-link" href=${productLink} title=${product.title}>
                  <h3 class="product-card__title f-family--heading f-caps--false f-space--0">
                    ${titleMain.toUpperCase()}
                  </h3>
                </a>

                <div class="product-card__details__hover u-medium">
                  <a class="product-card__variants" href=${productLink}>
                    ${titleSub ? html`<p class="colour">${titleSub}</p>` : null}
                  </a>
                  <a class="product-card__link js-product-link" href=${productLink} title=${product.title} tabindex="-1">
                    <p class="price">
                      ${isOnSale ? html`
                        <strike class="price__compare">
                          <span class="money">${helpers.formatCurrency(product.compare_at_price)}</span>
                        </strike>
                        <span class="price__number price__number--sale">
                          <span class="money">${helpers.formatCurrency(product.price)}</span>
                        </span>
                      ` : html`
                        <span class="price__number">
                          <span class="money">${helpers.formatCurrency(product.price)}</span>
                        </span>
                      `}
                    </p>
                  </a>
                </div>
              </div>
            </div>
          `;
        },
      },
      widget: {
        labels: {
          searchResults: {
            heading: {
              standard: '{{resultsCount}} search results for "{{searchTerm}}"',
              corrected:
                "No results for ‘{{originalSearchTerm}}’. Showing {{resultsCount}} results for ‘{{correctedSearchTerm}}’ instead.",
              partialMatches:
                "No products exactly match ‘{{searchTerm}}’. Showing products that partially match.",
            },
            productsCount: "{{productsCount}} products",
            noResultsHeading:
              "Sorry! No products found. But here are some recommendations for you.",
          },
          filters: {
            heading: "Filters",
            clearAllFilters: "Clear all",
            clearIndividualFilter: "Clear",
            drawerFilterToggle: "Filter by",
            rangeFilterValueSeparator: "to",
          },
          sortOptions: {
            sortBy: "Sort by",
          },
          pagination: {
            firstPage: "First",
            previousPage: "Previous",
            nextPage: "Next",
            loadNext: "Load more",
            loadPrevious: 'Load previous',
            loading: "Loading...",
          },
        },
        options: {
          selector: '.search-results-container',
          includeTagalysCSS: false,
          canAppendQueryStringToUrl: true,
          perPage: 60,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          if (helpers.isInitialLoading()) {
            return html` <${args.templates.loader} /> `;
          }

          let classes = ["plp", "search-results"];
          if (helpers.isFilterDrawerOpen()) {
            classes.push("filter-drawer-opened");
          }
          if (helpers.isLoading()) {
            classes.push("loading");
          }
          if (helpers.canShowFiltersInDrawer()) {
            classes.push("show-filters-in-drawer");
          }

          var className = classes.join(" ");

          if (helpers.hasNoSearchResults()) {
            var container = document.querySelector('.search-page .search__container');
            container.classList.add("no-results");
            var id = TagalysCustomisations.recommendations['mixed'];
            if (!id) return;
            TagalysCustomisations.initSmartWidgetRecommendations("[data-widget='search-results-recommendations']", id);
            return html`
              <div class="cc-fs1 cc-uppercase search-draw__heading">No Results found for "${helpers.getQuery()}"</div>
              <div data-widget='search-results-recommendations'> </div>
            `;
          }

          return html`
            <div class=${className}>
              <${args.templates.header} />
              ${helpers.isFilterDrawerOpen() ? html` <div class="filter-overlay" onclick=${helpers.closeFilterDrawer}/>` : null}
              <div class="filters-and-products-list">
                <${args.templates.filters} />
                <div class="products-list">
                  <${args.templates.products} />
                  <${args.templates.productListFooter} />
                </div>
              </div>
              <${args.templates.footer} />
            </div>
          `;
        },
      },
    },
    callbacks: {
      beforeAPICall: function (params, helpers) {


        document.querySelectorAll('[data-search-input]').forEach((item) => {
          item.value = params.query;
        });

        var filters = params.filters == null
          ? []
          : (Array.isArray(params.filters) ? params.filters : Object.entries(params.filters));

        const isEmptyFiltersArray = filters.length === 0;
        if (!TagalysCustomisations.didApplyInitialGenderFilter && (params.filters == null || isEmptyFiltersArray)) {
          var gender = TagalysCustomisations.getSelectedGenderValue();
          var genders = gender ? [gender] : [];
          if (gender === 'mens' || gender === 'womens') {
            genders = [gender, 'unisex'];
          }
          params.filters = {
            "p.m.custom.gender": genders, // Pass in respective filter ids to filter search results
          };
          TagalysCustomisations.didApplyInitialGenderFilter = true;
        }
        return params;
      },
      afterInitialRender: function(helpers) {
        const searchLoader = document.querySelector('.search-filters-loading');
        searchLoader.classList.add('u-hidden');
      },
      onSuccessfulAPICall: async function (response) {
        const products = response.products || [];

        // get all collection handles to query
        const productToCollectionHandleMap = new Map();
        products.forEach((product) => {
          const sku = product.variants[0].sku;
          productToCollectionHandleMap.set(product.id, constructCollectionHandle(sku));
        });

        // Fetch all collections at once
        const collectionsData = await fetchCollectionsData([
          ...new Set(productToCollectionHandleMap.values()),
        ]);

        // Attaching swatches to each product, excluding the product itself from its swatch list
        response.products = products.map((product) => {
          const collectionHandle = productToCollectionHandleMap.get(product.id);
          const collectionProducts = collectionsData[collectionHandle];

          return collectionProducts
            ? {
                ...product,
                swatches: collectionProducts.filter(
                  (p) => p.handle !== product.handle
                ),
              }
            : product;
        });

        return response;
      },
    },
  });

}
